import React from 'react';
import './menu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok, faYoutube, faPatreon } from '@fortawesome/free-brands-svg-icons';
import { useLanguage } from './contexts/LanguageContext';

const Menu = ({ isOpen, currentMenu, onNavigate, onBack, activeSection, setIsMenuOpen, setShowTeam, setCurrentMenu, setShowPrivacyPolicy }) => {
  const { t } = useLanguage();
  const [manualNavigation, setManualNavigation] = React.useState(false);
  
  // Reset manual navigation when menu closes or active section changes
  React.useEffect(() => {
    if (!isOpen || isOpen) {
      setManualNavigation(false);
    }
  }, [isOpen, activeSection]);
  
  const mainMenu = [
    { id: 'home', label: t('nav.home') },
    { id: 'about', label: t('nav.about') },
    { id: 'projects', label: t('nav.projects') },
    { id: 'campaigns', label: t('nav.campaigns') },
    { id: 'principles', label: t('nav.principles') },
    { id: 'beapart', label: t('nav.beapart') },
    { id: 'contact', label: t('nav.contact') }
  ];

  const projectsMenu = [
    { id: 'dominican', label: t('projectsSubmenu.dominican'), url: 'https://ngoproject.phnx.dev/dominican-republic/'},
    { id: 'chile', label: t('projectsSubmenu.chile'), url: 'https://ngoproject.phnx.dev/chile/'},
    { id: 'colombia', label: t('projectsSubmenu.colombia'), url: 'https://ngoproject.phnx.dev/colombia/' },
    { id: 'ecuador', label: t('projectsSubmenu.ecuador'), url: 'https://ngoproject.phnx.dev/ecuador/' },
    { id: 'haiti', label: t('projectsSubmenu.haiti'), url: 'https://ngoproject.phnx.dev/haiti/' },
    { id: 'peru', label: t('projectsSubmenu.peru'), url: 'https://ngoproject.phnx.dev/peru/' },
    { id: 'western-sahara', label: t('projectsSubmenu.westernSahara'), url: 'https://ngoproject.phnx.dev/western-sahara/' }
  ];

  const aboutMenu = [
    { id: 'who-we-are', label: t('aboutSubmenu.whoWeAre'), section: 0 },
    { id: 'our-story', label: t('aboutSubmenu.ourStory'), section: 1 },
    { id: 'what-we-do', label: t('aboutSubmenu.whatWeDo'), section: 2 },
    { id: 'mission', label: t('aboutSubmenu.mission'), section: 3 },
    { id: 'vision', label: t('aboutSubmenu.vision'), section: 4 }
  ];

  const renderMenuItems = () => {
    // Show submenu automatically when in about or projects section and menu is open
    // but only if user hasn't manually navigated away
    if (isOpen && currentMenu === 'main' && !manualNavigation && 
        (activeSection === 'about' || activeSection === 'projects')) {
      if (activeSection === 'about') {
        return (
          <>
            <li className="menu-header">{t('submenu.about')}</li>
            {aboutMenu.map(item => (
              <li 
                className="menu-projects" 
                key={item.id}
                onClick={() => {
                  setIsMenuOpen(false);
                  // Close expanded story if it's currently visible
                  if (window.showOurStoryExpanded) {
                    window.showOurStoryExpanded = false;
                    window.showSections = true;
                    document.body.style.height = `${window.innerHeight * 5}px`;
                  }
                  // Trigger about section selection
                  window.dispatchEvent(new CustomEvent('aboutSectionSelect', {
                    detail: { section: item.section }
                  }));
                }}
              >
                <span className="menu-link">{item.label}</span>
              </li>
            ))}
            <li 
              className="back-button"
              onClick={() => {
                setManualNavigation(true);
                setCurrentMenu('main');
              }}
            >
              {t('submenu.back')}
            </li>
          </>
        );
      } else if (activeSection === 'projects') {
        return (
          <>
            <li className="menu-header">{t('submenu.projects')}</li>
            {projectsMenu.map(project => (
              <li 
                className="menu-projects" 
                key={project.id}
                onClick={() => {
                  setIsMenuOpen(false);
                  // Trigger project selection by matching the URL format
                  const projectUrl = project.url.split('/').slice(-2)[0];
                  window.dispatchEvent(new CustomEvent('projectSelect', {
                    detail: { url: projectUrl }
                  }));
                }}
              >
                <a href={project.url}>{project.label}</a>
              </li>
            ))}
            <li 
              className="back-button"
              onClick={() => {
                setManualNavigation(true);
                setCurrentMenu('main');
              }}
            >
              {t('submenu.back')}
            </li>
          </>
        );
      }
    }
    
    switch(currentMenu) {
      case 'projects-submenu':
        return (
          <>
            <li className="menu-header">{t('submenu.projects')}</li>
            {projectsMenu.map(project => (
              <li 
                className="menu-projects" 
                key={project.id}
                onClick={() => {
                  setIsMenuOpen(false);
                  // Trigger project selection by matching the URL format
                  const projectUrl = project.url.split('/').slice(-2)[0];
                  window.dispatchEvent(new CustomEvent('projectSelect', {
                    detail: { url: projectUrl }
                  }));
                }}
              >
                <a href={project.url}>{project.label}</a>
              </li>
            ))}
            <li 
              className="back-button"
              onClick={() => setCurrentMenu('main')}
            >
              {t('submenu.back')}
            </li>
          </>
        );
      case 'about-submenu':
        return (
          <>
            <li className="menu-header">{t('submenu.about')}</li>
            {aboutMenu.map(item => (
              <li 
                className="menu-projects" 
                key={item.id}
                onClick={() => {
                  setIsMenuOpen(false);
                  // Close expanded story if it's currently visible
                  if (window.showOurStoryExpanded) {
                    window.showOurStoryExpanded = false;
                    window.showSections = true;
                    document.body.style.height = `${window.innerHeight * 5}px`;
                  }
                  // Trigger about section selection
                  window.dispatchEvent(new CustomEvent('aboutSectionSelect', {
                    detail: { section: item.section }
                  }));
                }}
              >
                <span className="menu-link">{item.label}</span>
              </li>
            ))}
            <li 
              className="back-button"
              onClick={() => setCurrentMenu('main')}
            >
              {t('submenu.back')}
            </li>
          </>
        );
      default:
        return mainMenu.map(item => {
          const isActive = activeSection === item.id.toLowerCase();
          return (
            <li 
              key={item.id} 
              onClick={() => {
                if (item.id === 'home') {
                  setIsMenuOpen(false);
                  window.scrollTo({top: 0, behavior: 'smooth'});
                  setCurrentMenu('main');
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                } else if (item.id === 'projects') {
                  setCurrentMenu('projects-submenu');
                  onNavigate(item.id);
                  setIsMenuOpen(true);
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                }
                else if (item.id === 'about') {
                  setCurrentMenu('about-submenu');
                  onNavigate(item.id);
                  setIsMenuOpen(true);
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                } 
                else if (item.id === 'campaigns') {
                  setCurrentMenu('main');
                  setIsMenuOpen(false);
                  onNavigate(item.id);
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                }
                else if (item.id === 'principles') {
                  setCurrentMenu('main');
                  setIsMenuOpen(false);
                  onNavigate(item.id);
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                } 
                else if (item.id === 'beapart') {
                  setCurrentMenu('main');
                  setIsMenuOpen(false);
                  onNavigate(item.id);
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                } 
                else if (item.id === 'contact') {
                  setCurrentMenu('main');
                  setIsMenuOpen(false);
                  onNavigate(item.id);
                  setShowTeam(false);
                  setShowPrivacyPolicy(false);
                } 
                else {
                  onNavigate(item.id);
                }
              }}
              className={isActive ? 'active' : ''}
            >
              {item.label}
            </li>
          );
        });
    }
  };

  return (
    <div className={`menu ${isOpen ? 'open' : ''}`}>
      <ul className="menu-items">
        {renderMenuItems()}
      </ul>
        <div className="social-icons">
          <a className="socialicon" href="https://your-ngo.org" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a className="socialicon" href="https://tiktok.com/@yourngo" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTiktok} />
          </a>
          <a className="socialicon" href="https://youtube.com/@yourngo2323" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a className="socialicon" href="https://patreon.com/YourNGO" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faPatreon} />
          </a>
        </div>
    </div>
  );
};

export default Menu;
